/**
 * Slim replacement for the full `lodash` build, aliased in next.config.js.
 * `@sourceflow-uk/sourceflow-sdk` is the only bare-lodash importer in the
 * client bundle and uses only these methods; per-method imports keep the
 * 70kb monolith out of the _app chunk.
 */

import filter from "lodash/filter";
import find from "lodash/find";
import has from "lodash/has";
import isObject from "lodash/isObject";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import pick from "lodash/pick";

export { filter, find, has, isObject, map, orderBy, pick };
export default { filter, find, has, isObject, map, orderBy, pick };
